module.exports = __webpack_public_path__ + "img/logo_wcaworld1.e3a87ccb.png";